import React, { useState, useEffect, useCallback, useRef } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import { Icon, Loader, Button } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  CreateButton,
  SemanticTable,
} from "./styled";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../../services/auth";

const CombosPlataforma = (props) => {
  const [search, setSearch] = useState("");
  const [combos, setCombos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAuth();
    api
      .get("/combos-nome/")
      .then(async (res) => {
        let logs = { local: "ead/combos", texto: `listou os combos` };
        await api.post("system_logs", { acao: JSON.stringify(logs) });
        setCombos([...combos, ...res.data]);
        setLoading(false);
      })
      .catch((err) => {
        swal("Não foi possível carregar os combos", err, "").then((res) =>
          props.history.push("/")
        );
      });
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const verifyCurso = (curso) => {
    if (curso == null) {
      return "sem nome";
    } else {
      return curso;
    }
  };

  return (
    <>
      <Container>
        <AdminMenu />

        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>Combos</Title>

            <ContainerInputSearch className="ui fluid left icon input">
              <Input
                type="search"
                placeholder="Procurar COMBOS..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <Icon name="search icon" />

              <CreateButton to="/admin/ead/combos/criar">Criar</CreateButton>
            </ContainerInputSearch>

            <SemanticTable size="big" celled>
              <SemanticTable.Header>
                <SemanticTable.Row>
                  <SemanticTable.HeaderCell>Id</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Curso</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Ações </SemanticTable.HeaderCell>
                </SemanticTable.Row>
              </SemanticTable.Header>
              <SemanticTable.Body>
                {combos
                  .filter((combo) =>
                    verifyCurso(combo.curso)
                      .toLowerCase()
                      .includes(search.toLowerCase())
                  )
                  .map((combo, index) => (
                    <SemanticTable.Row>
                      <SemanticTable.Cell>{combo.id_combo}</SemanticTable.Cell>
                      <SemanticTable.Cell style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}><img src={`https://files.voitto.com.br/cursos/small/${combo.url_amigavel}.jpg`} alt={'Capa do combo'} style={{ width: '130px', height: "auto", objectFit: "cover", borderRadius: "5px" }} />{combo.curso}</SemanticTable.Cell>
                      <SemanticTable.Cell>
                        <>
                          <Button
                            icon="edit icon"
                            color={"blue"}
                            onClick={() =>
                              window.open(
                                `/admin/ead/combos/detalhes/${combo.id_combo}`
                              )
                            }
                          />
                        </>
                      </SemanticTable.Cell>
                    </SemanticTable.Row>
                  ))}
              </SemanticTable.Body>
            </SemanticTable>
          </Content>
        )}
      </Container>
    </>
  );
};

export default withRouter(CombosPlataforma);
